
<div class="container">
   
        <mat-tab-group class="custom-tab-group">
            <mat-tab  label="PROFILE">
                <br />
                <form [formGroup]="ownerForm" >
                  
                        <div class="row gap-10">
                            <div class="col-md-7 col-xs-12">
                                <div class="row">
                                    <mat-form-field appearance="outline" requiered>
                                        <mat-label style="font-size: 16px !important">First name</mat-label>
                                        <input matInput formControlName="firstName" placeholder="First name" required />
                                        <mat-error> First name is required</mat-error>
                                      </mat-form-field>
                                </div>
        
                                <div class="row">
                                    <mat-form-field appearance="outline" requiered>
                                        <mat-label style="font-size: 16px !important">Last name</mat-label>
                                        <input matInput formControlName="lastName" placeholder="First name" required />
                                        <mat-error>Last name is required</mat-error>
                                      </mat-form-field>
                                </div>
        
                                <div class="row">
                                    <mat-form-field appearance="outline">
                                      <mat-label style="font-size: 16px !important">Owner’s email address</mat-label>
                                      <input matInput formControlName="email" placeholder="Owner’s Email" required />
                                      <mat-error
                                        *ngIf="this.ownerForm.get('email')?.errors?.['email'] && (ownerForm.get('email')?.touched)">Owner’s
                                        email address is invalid</mat-error>
                        
                                      <mat-error
                                        *ngIf="this.ownerForm.get('email')?.errors?.['required'] && (ownerForm.get('email')?.touched)">Owner’s
                                        email address is required</mat-error>
                                    </mat-form-field>
                                  </div>
                                  <div class="row">
                                    <mat-form-field appearance="outline">
                                      <mat-label style="font-size: 16px !important">Owner’s Phone Number</mat-label>
                                      <input matInput formControlName="phoneNumber" placeholder="Owner’s Phone Number" required />
                                      <mat-error
                                        *ngIf="this.ownerForm.get('phoneNumber')?.errors?.['pattern'] && (ownerForm.get('phoneNumber')?.touched)">Owner’s
                                        Phone number is invalid</mat-error>
                        
                                      <mat-error
                                        *ngIf="this.ownerForm.get('phoneNumber')?.errors?.['required'] && (ownerForm.get('phoneNumber')?.touched)">Owner’s
                                        Phone number is required</mat-error>
                        
                                      <mat-error></mat-error>
                                    </mat-form-field>
                                  </div>
    
                                  <div class="row gap-32 flex-direction-xs-col">
                                    <mat-radio-group aria-label="Select owner’s address type">
                                      <div class="row flex align-item-center gap-10">
                                        <div class="col-md-12">
                                          <mat-label> Select owner’s address type</mat-label>
                                        </div>
                                        <div class="col">
                                          <mat-radio-button (change)="radioChangeAddress($event)" [checked]="true" color="primary"
                                            value="1">Domestic</mat-radio-button>
                                        </div>
                                        <div class="col">
                                          <mat-radio-button (change)="radioChangeAddress($event)" color="primary" value="2">International</mat-radio-button>
                                        </div>
                                      </div>
                                    </mat-radio-group>
                                  </div>
                                    <div class="col-md-8 col-xs-12">
                                        <div *ngIf="addressType == '1'" class="row">
                                          <mat-form-field class="full-width" appearance="outline">
                                            <mat-label>Owners Street Address</mat-label>
                                            <input matInput class="form-outline form-control" placeholder="Owners Street Address"
                                              formControlName="ownerStreetAddress" [matAutocomplete]="auto" />
                                            <mat-autocomplete #auto="matAutocomplete">
                                              <mat-option *ngFor="let suggestion of suggestions" [value]="suggestion.description"
                                                (onSelectionChange)="selectPlace(suggestion)">
                                                {{ suggestion.description }}
                                              </mat-option>
                                            </mat-autocomplete>
                                            <mat-error>Owners Street Address is required</mat-error>
                                          </mat-form-field>
                                        </div>
                                        <div *ngIf="addressType == '2'" class="row">
                                          <mat-form-field class="full-width" appearance="outline">
                                            <mat-label>Addressee's Full Legal name</mat-label>
                                            <input class="form-outline form-control" formControlName="addressName" matInput
                                              placeholder="Addressee's Full Legal name" />
                              
                                            <mat-error>Addressee's Full Legal name is required</mat-error>
                                          </mat-form-field>
                                        </div>
                                        <div *ngIf="addressType == '1'" class="row">
                                          <mat-form-field appearance="outline">
                                            <mat-label>Apt/Unit/Suite</mat-label>
                                            <input matInput formControlName="aptUnitSuite" placeholder="Apt/Unit/Suite" />
                                          </mat-form-field>
                                        </div>
                                        <div *ngIf="addressType == '2'" class="row">
                                          <mat-form-field class="full-width" appearance="outline">
                                            <mat-label>Street address or post office box number</mat-label>
                                            <input formControlName="addressOrPoBox" class="form-outline form-control" matInput
                                              placeholder="Street address or post office box number" />
                              
                                            <mat-error>Street address or post office box number is required</mat-error>
                                          </mat-form-field>
                                        </div>
                                        <div *ngIf="addressType == '1'" class="row gap-10">
                                            <div class="col-md-2 col-xs-12">
                                            <mat-form-field c appearance="outline">
                                              <mat-label>City</mat-label>
                                              <input matInput formControlName="city" placeholder="City" />
                                              <mat-error>City is required</mat-error>
                                            </mat-form-field>
                                          </div>
                                          <div class="col-md-2 col-xs-12">
                                            <mat-form-field appearance="outline">
                                              <mat-label>State</mat-label>
                              
                                              <mat-select formControlName="state" placeholder="State">
                                                @for (state of states; track state) {
                                                <mat-option [value]="state.id.toString()">{{
                                                  state.name
                                                  }}</mat-option>
                                                }
                                              </mat-select>
                              
                                              <mat-error>State is required</mat-error>
                                            </mat-form-field>
                                          </div>
                                          <div class="col-md-2 col-xs-12">
                                            <mat-form-field appearance="outline">
                                              <mat-label>Zip Code</mat-label>
                                              <input matInput formControlName="zipCode" laceholder="Zip Code" />
                                              <mat-error
                                                *ngIf="this.ownerForm.get('zipCode')?.errors?.['pattern'] && (ownerForm.get('zipCode')?.touched)">Zip
                                                Code is invalid</mat-error>
                              
                                              <mat-error
                                                *ngIf="this.ownerForm.get('zipCode')?.errors?.['required'] && (ownerForm.get('zipCode')?.touched)">Zip
                                                Code is required</mat-error>
                                            </mat-form-field>
                                          </div>
                                        </div>
                                        <div *ngIf="addressType == '2'" class="row">
                                          <mat-form-field class="full-width" appearance="outline">
                                            <mat-label>City, State, Province and Postal Code</mat-label>
                                            <input class="form-outline form-control" formControlName="cityStateProvince" matInput
                                              placeholder="City, State, Province and Postal Code" />
                              
                                            <mat-error>City, State, Province and Postal Code is required</mat-error>
                                          </mat-form-field>
                                        </div>
                                        <div class="row" style="min-height: 56px">
                                          <mat-form-field class="full-width" appearance="outline" *ngIf="addressType == '2'">
                                            <mat-label>Country</mat-label>
                              
                                            <mat-select formControlName="country" placeholder="Country">
                                              @for (state of country; track state) {
                                              <mat-option [value]="state.id">{{ state.name }}</mat-option>
                                              }
                                            </mat-select>
                                            <mat-error>Country is required</mat-error>
                                          </mat-form-field>
                                        </div>
                                   
                                  </div>
                            </div>
                          
                            <div class="col-md-4 col-xs-12">
                                
                                <div class="row">
                                    <div class="col">
                                      <mat-form-field appearance="outline">
                                        <mat-label>Notes</mat-label>
                                        <textarea matInput formControlName="note" placeholder="Notes"></textarea>
                                      </mat-form-field>
                                    </div>
                                  </div>
                                  <div class="row">

                                    <mat-form-field  appearance="outline">
                                        <mat-label>Printed Name / eSignature</mat-label>
                                        <input id="printedName" formControlName="printedName"   matInput placeholder="Printed Name">
                                        <mat-error>Printed Name is required</mat-error>
                                      </mat-form-field>
                                  </div>
                            </div>
                        </div>
                   
                    
                </form>
         
               
            </mat-tab>
        </mat-tab-group>
        <div  style="bottom: 0; width: 100%; background-color: white">
            <div   class="button-stepper-footer">
                <button (click)="save()"
                [disabled]="!ownerForm.valid"
                [ngClass]="{
                  'button-stepper-allow': ownerForm.valid,
                  'button-stepper': ownerForm.invalid
                }"
                mat-stroked-button
                mat-button
                class="button-stepper-allow"
              >
              SAVE <mat-icon >save</mat-icon>
              </button>
            </div>
        </div>
</div>
